import { z } from 'zod';
import { IsoDateSchema } from './common.js';
const n = z.number().nullable();
export const ChartmetricSnapshotSchema = z.object({
    linked: z.boolean(),
    chartmetricId: z.number().int().nullable(),
    observedOn: IsoDateSchema.nullable(),
    source: z.literal('enigma-silver'),
    profile: z.object({
        stage: z.string().nullable(),
        stageScore: n,
        trend: z.string().nullable(),
        rank: z.number().int().nullable(),
        country: z.string().nullable(),
    }),
    stats: z.object({
        spMonthlyListeners: n,
        spMonthlyListenersRank: n,
        spFollowers: n,
        spFollowersRank: n,
        spPopularity: n,
        playlistReach: n,
        editorialReach: n,
        instagram: n,
        tiktok: n,
        youtubeSubs: n,
        youtubeMonthlyViews: n,
        shazam: n,
    }),
});
//# sourceMappingURL=chartmetric.js.map